import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Icon,
} from '@chakra-ui/react';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { EnrolmentForm } from './EnrolmentForm';
import { BoxIcon } from 'lucide-react';
import type { RouterOutputs } from '@duke-hq/svc-api/provider';

export type StudentType = RouterOutputs['users']['studentById'];

interface EnrolmentFormButtonProps {
  label?: string;
  student?: StudentType | null | undefined;
  referral?: boolean;
  button?: ({ onOpen }: { onOpen: () => void }) => React.ReactNode;
}

const EnrolmentFormModal = forwardRef<
  { openEnrolmentForm: (student?: StudentType) => void },
  EnrolmentFormButtonProps
>(({ label, student, referral, button }, ref) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [studentSelected, setStudentSelected] = useState<StudentType | undefined>(
    student ?? undefined,
  );
  const [referralSelected, setReferralSelected] = useState<boolean | undefined>(referral);

  useImperativeHandle(ref, () => ({
    openEnrolmentForm(student?: StudentType) {
      onOpen();
      if (student) {
        setReferralSelected(true);
        setStudentSelected(student);
      }
    },
  }));

  const openEnrolmentForm = () => {
    if (!student) {
      setReferralSelected(false);
      setStudentSelected(undefined);
    }
    onOpen();
  };

  return (
    <>
      {button ? (
        button({ onOpen })
      ) : (
        <Button size="sm" onClick={openEnrolmentForm} leftIcon={<Icon as={BoxIcon} />}>
          {label ? label : 'Refer to course'}
        </Button>
      )}

      <Modal isOpen={isOpen} onClose={onClose} size="2xl" closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box ml="auto">
              <EnrolmentForm
                student={studentSelected}
                referral={referralSelected}
                onClose={onClose}
              />
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
});

EnrolmentFormModal.displayName = 'EnrolmentFormModal';

export { EnrolmentFormModal };
